module.exports = __webpack_public_path__ + "static/media/placeholder.12d0fc49.png";